module.exports = __webpack_public_path__ + "img/activity11.41f47734.jpg";